export function formatContactType(type) {
  if (type === 'our') {
    return 'Наш клиент';
  } else if (type === 'arc' || type === 'req') {
    return 'Потенциальный клиент';
  } else {
    return 'Новый клиент';
  }
}



// WEBPACK FOOTER //
// ./src/utils/format-contact-type.js